<template>
  <div v-if="src">
    <form-request
      :action="src"
      method="post"
      v-slot="{ update, submit }"
    >
      <button
        type="button"
        @click="confirmAction(update, submit)"
        class="text-sm font-medium text-gray-600 pt-2"
      >
        Set As Featured
      </button>
    </form-request>
  </div>
</template>

<script>
import FormRequest from '@/Components/Forms/FormRequest'
import { useConfirmDialog } from '@/Composables/confirm-dialog'
import { settle } from '@/utils/promises'

export default {
  components: { FormRequest },
  props: {
    /**
     * If true this component will be visible
     */
    file: {
      type: Object,
      required: true
    },

    /**
     * The URL we send the request to
     */
    src: {
      type: String,
      default: null
    }
  },

  methods: {
    /**
     * Sends a request to the server asking to set the selected file as featured
     * @param update the function (provided by form-request component) to set the form params to send.
     * @param submit the function (provided by form-request component) that we use to send the http request
     */
    async confirmAction(update, submit) {
      const { show } = useConfirmDialog()
      const [error, data] = await settle(
        show({
          title: 'Set Featured Media',
          body: 'Are you sure you want to set ' + this.filename + ' as featured media?'
        })
      )
      if (!error) {
        update({ file: this.file })
        submit()
      }
    }
  },

  computed: {
    filename() {
      return this.file?.name || ''
    }
  }
}
</script>
